import { BaseAdvancedOperation } from './base-advanced-operation';
import { BaseArticleOperation } from './base-article-operation';
import { UndoAttachArticlesOperation } from './undo-attach-articles-operation';
import { UndoDetachArticlesOperation } from './undo-detach-articles-operation';

export class UndoReplaceArticleOperation extends BaseAdvancedOperation {
  constructor(protected _attachArticlesOperation: UndoAttachArticlesOperation, protected _detachArticlesOperation: UndoDetachArticlesOperation) {
    super();
  }

  public async performUndo(): Promise<void> {
    if (this._attachArticlesOperation) {
      await this._attachArticlesOperation.performUndo();
    }
    if (this._detachArticlesOperation) {
      await this._detachArticlesOperation.performUndo();
    }
    await super.performUndo();
  }

  public async performRedo(): Promise<void> {
    if (this._detachArticlesOperation) {
      await this._detachArticlesOperation.performRedo();
    }
    if (this._attachArticlesOperation) {
      await this._attachArticlesOperation.performRedo();
    }
    await super.performRedo();
  }

  public getQualifiedClassName(): string {
    return 'UndoReplaceArticleOperation';
  }

  public get attachArticleOperations(): BaseArticleOperation[] {
    return this._attachArticlesOperation ? this._attachArticlesOperation.articleOperations : [];
  }

  public get detachArticleOperations(): BaseArticleOperation[] {
    return this._detachArticlesOperation ? this._detachArticlesOperation.articleOperations : [];
  }

  public getOperationDescription(): string {
    return '';
  }
}
